import { useQuery } from '@tanstack/react-query';
import { enterpriseApiClient } from '../../client';
import { WorkOrdersApi } from '../../openapi';
import type { WorkOrderDetailViewModel } from '../../openapi';
import { workOrderKeys } from '../constants';
import { CACHE_TIMINGS } from '@api/constants';
import useOnlineStatus from '@hooks/useOnlineStatus';

export const useWorkOrderDetailsUnfiltered = (
  jobNumber: string,
  enabled = true
) => {
  const isOnline = useOnlineStatus();
  const workOrdersApi = new WorkOrdersApi(
    undefined,
    undefined,
    enterpriseApiClient
  );

  return useQuery<WorkOrderDetailViewModel[], Error>({
    queryKey: workOrderKeys.detailsUnfiltered(jobNumber),
    queryFn: async () => {
      const response = await workOrdersApi.apiWorkOrdersJobNumberDetailsGet({
        jobNumber
      });
      return response.data;
    },
    enabled: enabled && !!jobNumber && isOnline,
    refetchOnMount: isOnline,
    refetchOnWindowFocus: isOnline,
    ...CACHE_TIMINGS.WORK_ORDER
  });
};
